import React from 'react';
import { PackageCard } from './PackageCard';
import { Filter, Search, Minus, Plus, Package } from 'lucide-react';
interface Property {
  id: number;
  address: string;
  mq: number;
  rooms: number;
  bathrooms: number;
  timeWindow: string;
  tags: string[];
  lat: number;
  lng: number;
}
interface PackageData {
  id: number;
  name: string;
  zoneName: string;
  lat: number;
  lng: number;
  count: number;
  properties: Property[];
  baseEarnings: number;
  status: 'available' | 'accepted' | 'assigned' | 'completed';
  completedDate?: string;
  groupingReason?: string;
  groupingTags?: string[];
}
interface PackageListPanelProps {
  packages: PackageData[];
  activePackageId: number | null;
  onSelect: (id: number) => void;
  onEdit: () => void;
  onAccept: (id: number) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}
export function PackageListPanel({
  packages,
  activePackageId,
  onSelect,
  onEdit,
  onAccept,
  isCollapsed,
  onToggleCollapse
}: PackageListPanelProps) {
  // Collapsed state: small floating pill
  if (isCollapsed) {
    return <div className="absolute top-4 left-4 z-[500]" data-id="element-1534">
        <button onClick={onToggleCollapse} className="flex items-center gap-2.5 bg-white rounded-xl shadow-lg border border-gray-200 px-4 py-3 hover:shadow-xl transition-all group" data-id="element-1535">
          <div className="w-8 h-8 rounded-lg bg-teal-deep/10 flex items-center justify-center" data-id="element-1536">
            <Package size={16} className="text-teal-deep" data-id="element-1537" />
          </div>
          <div className="text-left" data-id="element-1538">
            <p className="text-sm font-semibold text-navy" data-id="element-1539">Opportunità</p>
            <p className="text-[11px] text-gray-500" data-id="element-1540">
              {packages.length} pacchetti
            </p>
          </div>
          <div className="ml-2 w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center group-hover:bg-teal-deep/10 transition-colors" data-id="element-1541">
            <Plus size={14} className="text-gray-500 group-hover:text-teal-deep" data-id="element-1542" />
          </div>
        </button>
      </div>;
  }
  // Expanded state: floating widget
  return <div className="absolute top-4 left-4 z-[500] w-[380px] max-h-[calc(100%-32px)] flex flex-col bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden" data-id="element-1543">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 bg-white" data-id="element-1544">
        <div className="flex items-center justify-between mb-3" data-id="element-1545">
          <div className="flex items-center gap-2.5" data-id="element-1546">
            <h1 className="text-lg font-bold font-montserrat text-navy" data-id="element-1547">
              Opportunità
            </h1>
            <span className="bg-teal-deep text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-1548">
              {packages.length}
            </span>
          </div>
          <button onClick={onToggleCollapse} className="w-8 h-8 rounded-lg bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" title="Riduci pannello" data-id="element-1549">
            <Minus size={14} className="text-gray-600" data-id="element-1550" />
          </button>
        </div>

        {/* Search/Filter Bar */}
        <div className="flex gap-2" data-id="element-1551">
          <div className="relative flex-1" data-id="element-1552">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" data-id="element-1553" />
            <input type="text" placeholder="Cerca zona..." className="w-full pl-9 pr-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" data-id="element-1554" />
          </div>
          <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50 text-gray-500" data-id="element-1555">
            <Filter size={18} data-id="element-1556" />
          </button>
        </div>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto p-3 space-y-3 bg-gray-50/50" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-1557">
        {packages.length > 0 ? packages.map(pkg => <PackageCard key={pkg.id} pkg={pkg} isActive={pkg.id === activePackageId} onSelect={onSelect} onEdit={onEdit} onAccept={onAccept} data-id="element-1558" />) : <div className="text-center py-10 px-4" data-id="element-1559">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-1560">
              <Filter className="text-gray-400 w-6 h-6" data-id="element-1561" />
            </div>
            <h3 className="text-sm font-semibold text-navy mb-1" data-id="element-1562">
              Nessun pacchetto trovato
            </h3>
            <p className="text-xs text-gray-500" data-id="element-1563">
              Prova a cambiare i filtri o cerca un'altra zona.
            </p>
          </div>}
      </div>
    </div>;
}